import { createFileRoute } from "@tanstack/react-router";
import { settingsIndexRoute, SettingsIndex } from "@/features/account-access";

export const Route = createFileRoute("/settings/")({
    head: settingsIndexRoute.head,
    component: SettingsIndex,
});
